<div class="loyalty-dashboard">
  <div class="loyalty-dashboard__header">
    <h1 class="loyalty-dashboard__title">{{ merchantName$ | async }}</h1>

    <div class="loyalty-dashboard__controls">
      <span class="loyalty-dashboard__peer-name" *ngIf="isImpersonation && (peerVerticalName$ | async) as peerName">
        {{ peerName }}
      </span>

      <p-selectButton
        class="loyalty-dashboard__period"
        [options]="periodOptions"
        [ngModel]="selectedPeriod"
        (onChange)="onPeriodChange($event.value)"
        [allowEmpty]="false"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>

      @if (selectedPeriod === CUSTOM_PERIOD) {
      <p-calendar
        class="loyalty-dashboard__range-date"
        [ngModel]="customFromDate"
        (ngModelChange)="onCustomFromDateChange($event)"
        [maxDate]="customToDate || maxDate"
        [showIcon]="true"
        [readonlyInput]="true"
        dateFormat="mm/dd/yy"
        placeholder="From date"
      ></p-calendar>
      <p-calendar
        class="loyalty-dashboard__range-date"
        [ngModel]="customToDate"
        (ngModelChange)="onCustomToDateChange($event)"
        [minDate]="customFromDate"
        [maxDate]="maxDate"
        [showIcon]="true"
        [readonlyInput]="true"
        dateFormat="mm/dd/yy"
        placeholder="To date"
      ></p-calendar>
      }
    </div>
  </div>

  <div class="loyalty-dashboard__pages">
    @for (page of pages$ | async; track $index) {
    <div class="loyalty-dashboard__page">
      <div class="loyalty-dashboard__page-grid">
        @for (widget of page; track widget.type) {
        <div class="tile" [class]="'tile--' + widget.size" [class.tile--placeholder]="widget.placeholder">
          @if (widget.status === 'loading') {
          <div class="tile__skeleton">
            <p-skeleton width="55%" height="1.1rem" />
            <p-skeleton width="35%" height="2rem" />
            <p-skeleton width="100%" height="3.5rem" />
          </div>
          } @else {
          <div class="tile__content">
            <ng-container *ngComponentOutlet="widget.component; inputs: { data: widget.data }" />
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
